module.exports = __webpack_public_path__ + "img/g177.677130ba.svg";